// TODO: Use global theming instead of hardcoding pixel values
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  appBar: {
    zIndex: 49,
  },
  title: {
    paddingLeft: 25,
    paddingRight: 16,
    justifyContent: 'center',
    fontFamily: 'lato-light',
    fontSize: '22px',
    lineHeight: '30px',
    alignItems: 'center',
    letterSpacing: '0.133333em',
    textTransform: 'uppercase',
    color: '#43485C',
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  container: {
    height: '32px',
    display: 'flex',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: 16,
    paddingLeft: 16,
    whiteSpace: 'nowrap',
  },
});
